import app from 'flarum/common/app';
import {TranslatedText} from '../json-settings';

export default function translate(value: TranslatedText) {
    if (value[app.data.locale]) {
        return value[app.data.locale];
    }

    return value.en || '';
}
